import axios from "../lib/axios";

export const sendEmail = async (payload) => {
  try {
    const response = await axios.post("/email-message/send", payload);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create message"
    );
  }
};

export const getLogs = async (lastId = null, limit = 10) => {
  try {
    const params = { limit };

    if (lastId) {
      params.lastId = lastId;
    }

    const response = await axios.get("/email-message/logs", { params });

    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to fetch email logs"
    );
  }
};
